var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4865 9.00083C15.4132 8.87863 15.291 8.80534 15.1688 8.80534L8.2051 8.80551L9.96436 0.449018C9.98873 0.277895 9.91545 0.106948 9.74449 0.0336584C9.57337 -0.039631 9.40242 0.00928578 9.30477 0.155864L0.0686465 13.3503C-0.00464293 13.4725 -0.0290162 13.6191 0.0442737 13.7413C0.117563 13.8635 0.239769 13.9368 0.361971 13.9368H7.30128L5.56636 21.5603C5.51745 21.7314 5.61528 21.9023 5.76186 21.9756C5.81061 22 5.85952 22 5.90844 22C6.03064 22 6.12831 21.9511 6.20159 21.8534L15.4377 9.39199C15.5354 9.26978 15.5599 9.1232 15.4866 9.001L15.4865 9.00083Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.3da21363e61ad8900c8d5a0f831592e0.svg";
export { ForwardRef as ReactComponent };